// extracted by mini-css-extract-plugin
export default {"modal":"ModalComponent_modal__MGEbn"};